/**
 * 되돌릴 수 없는 일을 묻는 자리.
 *
 * 우리가 그린 창 대신 브라우저 것을 쓴다. 기기가 늘 쓰는 그 모양이라, 화면 안의 카드보다
 * 먼저 "이건 다른 층의 일이다"로 읽힌다 — 실수로 지나치기 어렵다는 것이 이 창의 값이다.
 *
 * 대가가 하나 있다: 단추 글자(Cancel·OK)는 브라우저가 정하므로 "삭제"라고 쓸 수 없고 빨갛게
 * 둘 수도 없다. 그래서 무엇이 일어나는지는 전부 물음 쪽이 져야 한다.
 *
 * 줄을 비워 단락으로 가르지 않는다 — 두세 문장짜리 글에 단락이 생기면 둘이 다른 말처럼
 * 보이고, 창은 그만큼 키가 커진다. 묻는 말과 그래서 어떻게 되는지는 한 흐름이다.
 */
export function confirmAction(question: string, detail?: string) {
  return window.confirm(detail ? `${question} ${detail}` : question);
}
